import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { GeoPoint } from '@common/model/location/geopoint';
import { IConfigManager } from '@cp/shared/config';

const getPrice = (data: CatalogItemViewModel): number => {
  const FROM = 350,
    TO = 700,
    DIVIDER = 7;
  const inversionTable = {
    2: 6,
    4: 7,
  };
  const token = data.id % DIVIDER;
  return FROM + ((TO - FROM) * ((inversionTable[token] ?? token) / DIVIDER));
};

export const createSchema = (data: CatalogItemViewModel, title: string, config: IConfigManager) => {
  return {
    '@type': 'JobPosting',
    title,
    description: data.translation?.description,
    datePosted: data.createdAt,
    employmentType: ['FULL_TIME', 'PART_TIME'],
    hiringOrganization: {
      '@type': 'Organization',
      name: config.get('APP_NAME'),
      sameAs: config.get('CLIENT_WEB_ORIGIN'),
      logo: config.get('CLIENT_WEB_ORIGIN') + '/icons/android/512.svg',
    },
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        streetAddress: data.address,
        addressLocality: data.city?.translation.name,
        addressRegion: data.city?.translation.regionName,
        addressCountry: 'Россия',
      },
      latitude: data.location ? GeoPoint.fromDTO(data.location).lat : undefined,
      longitude: data.location ? GeoPoint.fromDTO(data.location).long : undefined,
    },
    baseSalary: {
      '@type': 'MonetaryAmount',
      currency: 'RUB',
      value: {
        '@type': 'QuantitativeValue',
        value: getPrice(data),
        unitText: 'HOUR',
      },
    },
    identifier: {
      '@type': 'PropertyValue',
      name: [data?.clientProfile?.surname, data.clientProfile?.name, data.clientProfile?.patronymic].filter(Boolean).join(' '),
      value: data.id,
    },
  };
};
